export const PostData = (url = '', data , obj , callback) => {
    fetch(url,{
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
        body: data
    }).then(response => {
        return response.text().then(text => {
            callback(obj,text);
        });
    }).catch(error => {
        if (error) {
            let errorR = {
                status: 'error-no-internet',
                data: {
                    message: 'اینترنت قطع می باشد'
                }
            }
            return callback(obj,JSON.stringify(errorR));
        }
    })
}


export const GetData = (url = '', obj , callback) => {
    fetch(url,{
        method: 'GET',
    }).then(response => {
        return response.text().then(text => {
            callback(obj,text);
        });
    }).catch(error => {
        let errorR = {
            status: 'error-no-internet',
            data: {
                message: 'اینترنت قطع می باشد'
            }
        }
        callback(obj,JSON.stringify(errorR));
    })
}

export const PostDataPromise = async (url = '', data) => {
    try {
        let response = await fetch(url,{
            method: 'POST',
            headers: {
                'Accept': 'application/json'
            },
            body: data
        });
        return await response.text();
    } catch(error) {
        if (error) {
            let errorR = {
                status: 'error-no-internet',
                data: {
                    message: 'اینترنت قطع می باشد'
                }
            }
            return JSON.stringify(errorR);
        }
    }
}
export const GetDataPromise = async (url = '') => {
    try {
        let response = await fetch(url,{
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        });
        return await response.text();
    } catch(error) {
        if (error) {
            let errorR = {
                status: 'error-no-internet',
                data: {
                    message: 'اینترنت قطع می باشد'
                }
            }
            return JSON.stringify(errorR);
        }
    }
}